export default "__VITE_ASSET__DufCBeEO__"